<div class="modal-header">
    <h4 class="modal-title pull-left" translate>Support ticket #{{ ticketId }}</h4>
    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="decline()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
    </button>
</div>
<div class="modal-body">
    <h4 translate>Are you sure you want to close this ticket?</h4>
    <p translate>
        This dialog will be set to "Closed" and all reminders will be stopped until the customer replies back
    </p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="decline()" translate>No, it is not finished</button>
    <button type="button" class="btn btn-primary" (click)="save()" translate>Yes, close the ticket</button>
</div>
